export enum PermissionName {
  ACCOUNT_CREATE = 'ACCOUNT_CREATE',
  ACCOUNT_EDIT = 'ACCOUNT_EDIT',
  ACCOUNT_DETAILS = 'ACCOUNT_DETAILS',

  ARTICLE_FAMILY_CREATE = 'ARTICLE_FAMILY_CREATE',
  ARTICLE_OPTION_PRICE_CREATE = 'ARTICLE_OPTION_PRICE_CREATE',
  ARTICLE_OPTION_TYPE_CREATE = 'ARTICLE_OPTION_TYPE_CREATE',
  ARTICLE_OPTION_CREATE = 'ARTICLE_OPTION_CREATE',
  ARTICLE_PRICE_CREATE = 'ARTICLE_PRICE_CREATE',
  ARTICLE_CREATE = 'ARTICLE_CREATE',
  ARTICLE_FAMILY_EDIT = 'ARTICLE_FAMILY_EDIT',
  ARTICLE_OPTION_PRICE_EDIT = 'ARTICLE_OPTION_PRICE_EDIT',
  ARTICLE_OPTION_TYPE_EDIT = 'ARTICLE_OPTION_TYPE_EDIT',
  ARTICLE_OPTION_EDIT = 'ARTICLE_OPTION_EDIT',
  ARTICLE_PRICE_EDIT = 'ARTICLE_PRICE_EDIT',
  ARTICLE_EDIT = 'ARTICLE_EDIT',
  ARTICLE_FAMILY_LIST = 'ARTICLE_FAMILY_LIST',
  ARTICLE_OPTION_PUBLIC_LIST = 'ARTICLE_OPTION_PUBLIC_LIST',
  ARTICLE_OPTION_TYPE_LIST = 'ARTICLE_OPTION_TYPE_LIST',
  ARTICLE_OPTION_LIST = 'ARTICLE_OPTION_LIST',
  ARTICLE_VIEW = 'ARTICLE_VIEW',
  ARTICLE_LIST = 'ARTICLE_LIST',
  ARTICLE_OPTION_PRICE_DELETE = 'ARTICLE_OPTION_PRICE_DELETE',
  ARTICLE_PRICE_DELETE = 'ARTICLE_PRICE_DELETE',

  ARTICLEPACK_CREATE = 'ARTICLEPACK_CREATE',
  ARTICLEPACK_EDIT = 'ARTICLEPACK_EDIT',
  ARTICLEPACK_LIST = 'ARTICLEPACK_LIST',
  ARTICLEPACK_DELETE = 'ARTICLEPACK_DELETE',

  CALENDARDAY_CREATE = 'CALENDARDAY_CREATE',
  CALENDARDAY_EDIT = 'CALENDARDAY_EDIT',
  CALENDARDAY_LIST = 'CALENDARDAY_LIST',

  CREDIT_CREATE = 'CREDIT_CREATE',
  CREDIT_EDIT = 'CREDIT_EDIT',
  CREDIT_USER_LIST = 'CREDIT_USER_LIST',
  CREDIT_DELETE = 'CREDIT_DELETE',

  DISCOUNTCODE_CREATE = 'DISCOUNTCODE_CREATE',
  DISCOUNTCODE_ISVALID = 'DISCOUNTCODE_ISVALID',
  DISCOUNTCODE_VIEW = 'DISCOUNTCODE_VIEW',
  DISCOUNTCODE_LIST = 'DISCOUNTCODE_LIST',

  DOCS_ARTICLETRACKING_TYPE = 'DOCS_ARTICLETRACKING_TYPE',
  DOCS_TRACKINGSHEET_TYPE = 'DOCS_TRACKINGSHEET_TYPE',
  DOC_QRCODETOKEN_TYPE = 'DOC_QRCODETOKEN_TYPE',

  EVENTCONFIG_CREATE = 'EVENTCONFIG_CREATE',
  EVENTCONFIG_EDIT = 'EVENTCONFIG_EDIT',
  EVENTCONFIG_DELETE = 'EVENTCONFIG_DELETE',

  HOUSE_CREATE = 'HOUSE_CREATE',
  HOUSE_DEFAULT = 'HOUSE_DEFAULT',
  HOUSE_EDIT = 'HOUSE_EDIT',
  HOUSE_USER_LIST = 'HOUSE_USER_LIST',
  HOUSE_DELETE = 'HOUSE_DELETE',

  LAVANDIER_QRCODE_CREATE = 'LAVANDIER_QRCODE_CREATE',
  LAVANDIER_CREATE = 'LAVANDIER_CREATE',
  LAVANDIER_QRCODE_DISABLE = 'LAVANDIER_QRCODE_DISABLE',
  LAVANDIER_EDIT = 'LAVANDIER_EDIT',
  LAVANDIER_DETAILS = 'LAVANDIER_DETAILS',
  LAVANDIER_LIST = 'LAVANDIER_LIST',

  LIGHT_EDIT = 'LIGHT_EDIT',
  LIGHT_DETAILS_LIST = 'LIGHT_DETAILS_LIST',
  LIGHT_BRIDGE_LIST = 'LIGHT_BRIDGE_LIST',
  LIGHT_LIST = 'LIGHT_LIST',

  NOTIFICATION_CREATE = 'NOTIFICATION_CREATE',

  ORDERARTICLETRACKING_DEFECT_CLOSE = 'ORDERARTICLETRACKING_DEFECT_CLOSE',
  ORDERARTICLETRACKING_REF_STORAGE_EDIT = 'ORDERARTICLETRACKING_REF_STORAGE_EDIT',
  ORDERARTICLETRACKING_SHOPSTORAGE_EDIT = 'ORDERARTICLETRACKING_SHOPSTORAGE_EDIT',
  ORDERARTICLETRACKING_UNTIDIED_EDIT = 'ORDERARTICLETRACKING_UNTIDIED_EDIT',
  ORDERARTICLETRACKING_FACTORY_EDIT = 'ORDERARTICLETRACKING_FACTORY_EDIT',
  ORDERARTICLETRACKING_DEFECT_CREATE = 'ORDERARTICLETRACKING_DEFECT_CREATE',
  ORDERARTICLETRACKING_TIDIED_EDIT = 'ORDERARTICLETRACKING_TIDIED_EDIT',
  ORDERARTICLETRACKING_REF_DETAILS = 'ORDERARTICLETRACKING_REF_DETAILS',

  ORDERBAG_ORDERARTICLE_CREATE = 'ORDERBAG_ORDERARTICLE_CREATE',
  ORDERBAG_STANDBY = 'ORDERBAG_STANDBY',
  ORDERBAG_FINISH = 'ORDERBAG_FINISH',
  ORDERBAG_CHECK = 'ORDERBAG_CHECK',
  ORDERBAG_EDIT = 'ORDERBAG_EDIT',
  ORDERBAG_TRANSPORTSHEET_REF_DETAILS = 'ORDERBAG_TRANSPORTSHEET_REF_DETAILS',
  ORDERBAG_NOTEMPTY_DETAILS_LIST = 'ORDERBAG_NOTEMPTY_DETAILS_LIST',
  ORDERBAG_REF_DETAILS = 'ORDERBAG_REF_DETAILS',
  ORDERBAG_DETAILS = 'ORDERBAG_DETAILS',
  ORDERBAG_ORDERARTICLE_DELETE = 'ORDERBAG_ORDERARTICLE_DELETE',

  ORDERSHIPRETURN_ID_VALIDATE = 'ORDERSHIPRETURN_ID_VALIDATE',
  ORDERSHIPRETURN_ID_SHIP = 'ORDERSHIPRETURN_ID_SHIP',
  ORDERSHIPRETURN_READYTOVALIDATE_LIST = 'ORDERSHIPRETURN_READYTOVALIDATE_LIST',
  ORDERSHIPRETURN_READYTOSHIP_LIST = 'ORDERSHIPRETURN_READYTOSHIP_LIST',

  ORDER_ORDERWANTEDDELIVERY_CREATE = 'ORDER_ORDERWANTEDDELIVERY_CREATE',
  ORDER_PAY_CREATE = 'ORDER_PAY_CREATE',
  ORDER_KITBATCH = 'ORDER_KITBATCH',
  ORDER_SEARCH = 'ORDER_SEARCH',
  ORDER_KIT_CREATE = 'ORDER_KIT_CREATE',
  ORDER_CREATE = 'ORDER_CREATE',
  ORDER_TRANSPORTSHEET = 'ORDER_TRANSPORTSHEET',
  ORDER_KITBATCH_EDIT = 'ORDER_KITBATCH_EDIT',
  ORDER_KIT_EDIT = 'ORDER_KIT_EDIT',
  ORDER_TRANSFER = 'ORDER_TRANSFER',
  ORDER_CANCEL_EDIT = 'ORDER_CANCEL_EDIT',
  ORDER_FINISH = 'ORDER_FINISH',
  ORDER_ORDERARTICLETRACKING_LIST = 'ORDER_ORDERARTICLETRACKING_LIST',
  ORDER_DETAILS = 'ORDER_DETAILS',
  ORDER_ORDERARTICLETRACKING_REF_DETAILS = 'ORDER_ORDERARTICLETRACKING_REF_DETAILS',
  ORDER_READYTOSHIP_LIST = 'ORDER_READYTOSHIP_LIST',
  ORDER_KITBATCH_LIST = 'ORDER_KITBATCH_LIST',
  ORDER_KIT_LIST = 'ORDER_KIT_LIST',
  ORDER_USER_HOUSENAME_LIST = 'ORDER_USER_HOUSENAME_LIST',
  ORDER_USER_LIST = 'ORDER_USER_LIST',
  ORDER_PIN_DETAILS = 'ORDER_PIN_DETAILS',
  ORDER_LIST = 'ORDER_LIST',

  ORDERTRANSPORT_CREATE = 'ORDERTRANSPORT_CREATE',
  ORDERTRANSPORT_REOPEN = 'ORDERTRANSPORT_REOPEN',
  ORDERTRANSPORT_DETAILS = 'ORDERTRANSPORT_DETAILS',
  ORDERTRANSPORT_LIST = 'ORDERTRANSPORT_LIST',

  PDF_INVOICE = 'PDF_INVOICE',

  ROLE_CREATE = 'ROLE_CREATE',
  ROLE_EDIT = 'ROLE_EDIT',
  ROLE_VIEW = 'ROLE_VIEW',
  ROLE_LIST = 'ROLE_LIST',

  SHIPPINGPRICE_CREATE = 'SHIPPINGPRICE_CREATE',
  SHIPPINGPRICE_EDIT = 'SHIPPINGPRICE_EDIT',
  SHIPPINGPRICE_DELETE = 'SHIPPINGPRICE_DELETE',

  SHOPSTORAGE_REF_VIEW = 'SHOPSTORAGE_REF_VIEW',

  STORAGE_EDIT = 'STORAGE_EDIT',
  STORAGE_USED_LIST = 'STORAGE_USED_LIST',
  STORAGE_LIST = 'STORAGE_LIST',

  TIMESLOT_CREATE = 'TIMESLOT_CREATE',
  TIMESLOT_TYPE_EDIT = 'TIMESLOT_TYPE_EDIT',
  TIMESLOT_TYPE_LIST = 'TIMESLOT_TYPE_LIST',
  TIMESLOT_DELETE = 'TIMESLOT_DELETE',

  TRACKINGSHEET_PTLTOOK = 'TRACKINGSHEET_PTLTOOK',
  TRACKINGSHEET_DETAILS = 'TRACKINGSHEET_DETAILS',
  TRACKINGSHEET_DETAILS_LIST = 'TRACKINGSHEET_DETAILS_LIST',
  TRACKINGSHEET_ORDER_LIST = 'TRACKINGSHEET_ORDER_LIST',
  TRACKINGSHEET_VIEW = 'TRACKINGSHEET_VIEW',

  TRACKINGSHEETSTORAGE_TIDIED = 'TRACKINGSHEETSTORAGE_TIDIED',
  TRACKINGSHEETSTORAGE_PREPARED = 'TRACKINGSHEETSTORAGE_PREPARED',
  TRACKINGSHEETSTORAGE_STORAGE = 'TRACKINGSHEETSTORAGE_STORAGE',

  TRANSPORTSHEET_USER_BOOK_EDIT = 'TRANSPORTSHEET_USER_BOOK_EDIT',
  TRANSPORTSHEET_FACTORYRECEIVED_EDIT = 'TRANSPORTSHEET_FACTORYRECEIVED_EDIT',
  TRANSPORTSHEET_FACTORYSENT_EDIT = 'TRANSPORTSHEET_FACTORYSENT_EDIT',
  TRANSPORTSHEET_HOUSE_EDIT = 'TRANSPORTSHEET_HOUSE_EDIT',
  TRANSPORTSHEET_USER_LIST = 'TRANSPORTSHEET_USER_LIST',
  TRANSPORTSHEET_REF_DETAILS = 'TRANSPORTSHEET_REF_DETAILS',
  TRANSPORTSHEET_ID_REPRINT = 'TRANSPORTSHEET_ID_REPRINT',
  TRANSPORTSHEET_DISABLE_EDIT = 'TRANSPORTSHEET_DISABLE_EDIT',

  UPLOAD_MULTIPLE_CREATE = 'UPLOAD_MULTIPLE_CREATE',
  UPLOAD_CREATE = 'UPLOAD_CREATE',
  UPLOAD_VIEW = 'UPLOAD_VIEW',

  USER_TYPE_CREATE = 'USER_TYPE_CREATE',
  USER_CREATE = 'USER_CREATE',
  USER_FORGOTTENPASSWORD = 'USER_FORGOTTENPASSWORD',
  USER_ANONYMISE_CANCEL_EDIT = 'USER_ANONYMISE_CANCEL_EDIT',
  USER_TYPE_EDIT = 'USER_TYPE_EDIT',
  USER_ENABLED = 'USER_ENABLED',
  USER_EDIT = 'USER_EDIT',
  USER_TIMESLOT_LIST = 'USER_TIMESLOT_LIST',
  USER_INTERCOM_CONVERSATION_LIST = 'USER_INTERCOM_CONVERSATION_LIST',
  USER_INTERCOM_REDIRECT_VIEW = 'USER_INTERCOM_REDIRECT_VIEW',
  USER_TYPE_DETAILS_LIST = 'USER_TYPE_DETAILS_LIST',
  USER_TYPE_VIEW = 'USER_TYPE_VIEW',
  USER_TYPE_LIST = 'USER_TYPE_LIST',
  USER_VIEW = 'USER_VIEW',
  USER_LIST = 'USER_LIST',
  USER_DELETE = 'USER_DELETE',
}
